<template>
    <div name="my" class="wrapper">
        <loading 
            v-if="isLoading"
        />
        <info-modal 
            v-if="isInfoModal"
            @onClose="infoModalClose"
            @onClick="goSoldocApp"
        />
        <select-modal 
            v-if="selectHospitalId !== -1"
            @onClose="selectModalClose"
            @onClick="selectModalClick"
        />
        <div class="page" style="padding: 20px 16px" v-if="isOnboarding">
            <span class="title">어떤 경로로 진료를 받으셨나요?</span>
            <div class="hospital-card" style="justify-content: space-between;height: 76px; margin-top: 32px;" @click="viewHospitalList">
                <span class="text1">병원 홈페이지에서 진료를 예약했어요 <br><span class="text2">디지털치료제, 블로그, 병원홍보물 등 웹으로 진료를 예약했어요.</span></span>
                <img style="width: 22px; cursor: pointer;" src="../../assets/right_arrow.png" />
            </div>
            <div class="hospital-card" style="justify-content: space-between;height: 76px;" @click="goSoldocApp"> 
                <span class="text1">솔닥 앱에서 진료를 예약했어요</span>
                <img style="width: 22px; cursor: pointer;" src="../../assets/right_arrow.png" />
            </div>
            <div class="hospital-card" style="justify-content: space-between;height: 76px;" @click="conciergeChannelTalk">
                <span class="text1">1형 당뇨 처방을 받았어요</span>
                <img style="width: 22px; cursor: pointer;" src="../../assets/right_arrow.png" />
            </div>
            <div class="row-normal" style="margin-top: 8px;">
                <img style="width: 22px;" src="../../assets/warning.png" />
                <span class="small-empty-text2" >다른 플랫폼에서 예약한 기록은 이곳에서 확인되지 않아요.</span> 
            </div>
        </div>
        <div class="page" v-else>

            <div class="row" style="justify-content: space-between;">
                <span class="title">병원 목록</span>
                <div class="row-normal"  v-if="list.length === 0"  @click="viewInfoModal">
                    <img style="width: 22px;" src="../../assets/warning.png" />
                    <span class="small-empty-text1" >예약한 병원이 안보이시나요?</span> 
                </div>
            </div>
            <div style="width: 100%;" v-if="list.length > 0">
                <div class="empty-bar" style="margin-top: 20px; margin-bottom: 32px;"  @click="viewInfoModal">
                    <div class="row-normal">
                        <img style="width: 22px;" src="../../assets/warning.png" />
                        <span class="small-empty-text2" >예약한 병원이 안보이시나요?</span>
                    </div>
                    <img style="width: 22px; cursor: pointer;" src="../../assets/right_arrow.png" />
                </div>
                <div class="hospital-card" v-for="(info, index) in list" @click="openHospitalLink(info.hospital.id)">
                    <img style="width: 36px;" src="../../assets/hospital_icn.png" />
                    <span class="hospital-text">{{ info.hospital.name }}</span>
                    <span class="dtx-label" v-if="info.classification === 'DTX'">디지털치료제(DTx)</span>
                </div>
            </div>
            <div v-else class="empty-list">
                <img style="width: 86px;" src="../../assets/chat_icn.png" />
                <span class="empty-list-title">방문한 병원이 없어요</span>
                <span class="empty-list-description">솔닥 앱에서 예약한 병원은<br>앱에서 확인할 수 있어요.</span>
                <div class="empty-list-button" @click="goSoldocApp">
                    앱에서 보기
                </div>
            </div>


        </div>

    </div>
</template>

<script>
import Constant from '@/constant';
import InfoModal from '@/components/my/InfoModal';
import SelectModal from '@/components/my/SelectModal';
import Loading from '@/components/molecules/Loading';

export default {
  components: { InfoModal, SelectModal, Loading },
    name: 'my',
    data: function()
    {
        return {
            list: [],
            kakaoId: '',
            isInfoModal: false,
            isOnboarding: true,
            selectHospitalId: -1,
            isLoading: false
        }
    },
    mounted: function()
    {
        if(this.$route.query.kakao)
        { 
            //
            this.afterLogin(this.$route.query.kakao);
            this.kakaoId = this.$route.query.kakao;
            this.$router.replace({ path: this.$route.path });
        }
        else
        {
            this.login();
        }
    },
    methods: {
        selectModalClick: function(menu)
        {
            this.isLoading = true;
            if(menu === 0)
            {
                this.$store.dispatch(Constant.AUTH_INAPP, {type: this.selectHospitalId, id: this.kakaoId, ref: null})
                    .then((response) => {
                        // console.log(response.replace("/booking/profile", "/medical/list/history"))
                        window.location.href = response; 
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
            }
            else 
            {
                this.$store.dispatch(Constant.AUTH_INAPP, {type: this.selectHospitalId, id: this.kakaoId, ref: null})
                    .then((response) => {
                        // console.log(response.replace("/booking/profile", "/medical/list/history"))
                        
                        if(response.indexOf("/booking/profile") !== -1)
                        {
                            window.location.href = response.replace("/booking/profile", "/medical/list/history"); 
                        }  
                        else if(response.indexOf("/booking/hospital/search") !== -1)
                        {
                             window.location.href = response.replace("/booking/hospital/search", "/medical/list/history"); 
                        }
                        // window.location.href = response.replace("/booking/profile", "/medical/list/history"); 
                        // window.location.href = response.replace("/booking/hospital/search", "/medical/list/history"); 
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
            }

            this.selectHospitalId = -1;
        },
        selectModalClose: function()
        {
            this.selectHospitalId = -1
        },
        conciergeChannelTalk: function()
        {
            window.open("https://baro.soldoc.co.kr", "_blank")
        },
        viewHospitalList: function()
        {
            if(this.list.length === 0)
            {
                this.isInfoModal = true;
            }
            else
            {
                this.isOnboarding = false
            }
        },
        infoModalClose: function()
        {
            this.isInfoModal = false;
        },
        goSoldocApp: function()
        {
            this.isInfoModal = false;
            window.location.href = 'https://official.soldoc.co.kr/api/v1/click/S81j3ZjSAkWd43rDQoo37A'
        },
        viewInfoModal: function()
        {
            this.isInfoModal = true;
        },
        login: function()
        {
            const REST_API_KEY = process.env.KAKAO_REST_API_KEY;
            const REDIRECT_URI = process.env.KAKAO_REDIRECT_URI;
            let STATE = `${process.env.LOGIN_URI}/my/hospital`;
            window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&response_type=code&prompt=login&state=${STATE}`;
        },
        afterLogin: function(uuid)
        {
            this.$store.dispatch(Constant.FETCH_USER_VISIT_INFOS, {uuid: uuid})
                .then((res) => {
                    this.list = res;
                })  
                .catch((err) => {

                })
        },
        openHospitalLink: function(hospitalId)
        {
            this.selectHospitalId = hospitalId;

            // alert(kakaoId)
            // this.$store.dispatch(Constant.AUTH_INAPP, {type: hospitalId, id: this.kakaoId, ref: null})
            //     .then((response) => {
            //         // console.log(response.replace("/booking/profile", "/medical/list/history"))
            //         window.location.href = response.replace("/booking/profile", "/medical/list/history"); 
            //     })
            //     .catch((err) => {

            //     })
        }

    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        height: 100dvh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .page {
        width: 100%;
        height: 100dvh;
        padding-top: 22px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        overflow-y: auto;
        position: relative;
    
    }
    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
        padding: 0 16px;
    }
    .row-normal {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    @media (min-width: 600px) {
        .page {
            width: 600px;
            height: 100dvh;
        }
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 120% */
    }
    .small-empty-text1{
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
        margin-left: 4px;
        cursor: pointer;
    }
    .small-empty-text2 {
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        margin-left: 4px;
        cursor: pointer;
    }
    .empty-bar {
        background: var(--Gray-20, #F3F5F8);
        width: 100%;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 8px 20px;
    }
    .hospital-card {
        border-radius: 6px;
        border: 1px solid var(--gray-30, #E8EAEE);
        background: var(--gray-00, #FFF);
        width: 100%;
        box-sizing: border-box;
        padding: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        margin-bottom: 8px;
        position: relative;
    }
    .hospital-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
        margin-left: 8px;
    }
    .empty-list {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .empty-list-title {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 120% */
        margin-top: 32px;
    }
    .empty-list-description {
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
        margin-top: 10px;
    }
    .empty-list-button {
        margin-top: 32px;
        border-radius: 100px;
        background: var(--gray-100, #1E1E1E);
        width: 92px;
        height: 40px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        cursor: pointer;
    }
    .text1 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .text2 {
        color: var(--gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
    }
    .dtx-label {
        border-radius: 3px;
        background: var(--semantic-light-blue, #E5F0FC);
        box-sizing: border-box;
        display: flex;
        padding: 5px 8px;
        justify-content: center;
        align-items: center;
        color: var(--semantic-blue, #008DEF);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        position: absolute;
        right: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/page/hospital/My.vue